import Transformer, { TRANSFORM_INPUT } from "+/Engine/Transformers/Transformer";
import DataTypes from "+/Engine/Helpers/DataTypes";

export default class Not extends Transformer {
  // eslint-disable-next-line no-unused-vars
  assertValidInput(value, _params) {
    DataTypes.assertBoolean(value);
  }

  // eslint-disable-next-line no-unused-vars
  [TRANSFORM_INPUT](value, _params) {
    return !value;
  }
}
Transformer.register("not", Not);
